import { FC } from 'react'
import groupBy from 'lodash/groupBy'
import first from 'lodash/first'
import type { TableHeaderProps } from './types'
import { getSort } from '../../utils/getSort'
import type { ColumnHeader } from '../../types'
import { flexRender } from '@tanstack/react-table'
import { TableHeaderCell } from '../HeaderCell'
import clsx from 'clsx'

export const TableHeader: FC<TableHeaderProps> = ({
  table,
  sortingState = [],
  columnDefinitions,
  striped,
  condensed = false,
}) => {
  const columnsById = groupBy(columnDefinitions, ({ id }) => id)
  return (
    <thead className="h-11">
      {table.getHeaderGroups().map((headerGroup) => (
        <tr
          key={headerGroup.id}
          className={clsx('border-b border-default', {
            'bg-medium': !striped,
            'bg-high': striped,
          })}
        >
          {headerGroup.headers.map((header) => {
            const sortOpts = getSort(header.column, sortingState)
            const headerValue = header.column.columnDef.header
            const transparentBackground =
              header.column.columnDef.meta?.transparentBackground

            if (header.isPlaceholder) return null
            if (
              typeof headerValue === 'string' ||
              typeof headerValue === 'number'
            ) {
              const { tooltipProps, justify } =
                first(columnsById[header.id as ColumnHeader['id']]) || {}
              return (
                <TableHeaderCell
                  column={header.column}
                  id={header.id}
                  justify={justify}
                  key={header.id}
                  tooltipProps={tooltipProps}
                  value={headerValue}
                  condensed={condensed}
                  transparentBackground={transparentBackground}
                  {...sortOpts}
                />
              )
            }
            return flexRender(
              header.column.columnDef.header,
              header.getContext(),
            )
          })}
        </tr>
      ))}
    </thead>
  )
}
